import classnames from 'classnames/bind'
import * as styles from './index.module.css'

const cx = classnames.bind(styles)

export default function FieldWrapper({ reverseLayout, flexStart, row, column, alternateBackground, isDisabled, isDisabledVisible, larger, responsive, noPadding, paddingTopBottom, hidden, children, onClick }) {
  return (
    <div className={cx(styles.wrapper, { reverseLayout, flexStart, row, column, alternateBackground, isDisabled, isDisabledVisible, larger, responsive, noPadding, paddingTopBottom, hidden, clickable: typeof onClick === 'function' })} onClick={onClick}>
      {children}
    </div>
  )
}
